import type { DateValue } from '@internationalized/date';
import { CalendarDate, getLocalTimeZone, today } from '@internationalized/date';
import type { Ref } from 'vue';
import { ref } from 'vue';

export const createDateValueRef = <DV extends DateValue>(dateValue: DV): Ref<DV | undefined> => {
    const dateValueRef = ref<DV>();
    dateValueRef.value = dateValue;
    return dateValueRef;
};

export const createToday = (): DateValue => {
    return today(getLocalTimeZone());
};

export const createCalendarDate = (year: number, month: number, day: number): DateValue => {
    return new CalendarDate(year, month, day);
};

export const createCalendarDateFromJS = (jsDate: Date): DateValue => {
    return new CalendarDate(
        jsDate.getFullYear(),
        jsDate.getMonth() + 1, // Convert 0-based to 1-based month
        jsDate.getDate(),
    );
};

export const calendarDateToNativeDate = (dateValue: DateValue, timeZone: string = getLocalTimeZone()): Date => {
    const tz = timeZone;
    return dateValue.toDate(tz);
};
